import { Component, Input, OnInit } from '@angular/core';
import { IBanner } from '../../interfaces/cart-details.interface';

@Component({
  selector: 'slot-banner',
  templateUrl: './slot-banner.component.html',
  styles: [`
    :host {
      display: contents;
    }
  `]
})
export default class SlotBannerComponent {
  @Input() data: IBanner
}
